import type { AriaAttributes } from "react"
import classNames from "classnames"

interface SwitchFieldProps extends Pick<AriaAttributes, "aria-label" | "aria-labelledby" | "aria-describedby"> {
  checked: boolean
  onChange: (checked: boolean) => void
  disabled?: boolean
}

// The DSL Switch Field on the global `.switch-field` classes (components/_switch_field.scss),
// which the ERB partial shares. A wrapping <label> only forwards clicks: name it with aria-*.
const SwitchField = ({ checked, onChange, disabled = false, ...aria }: SwitchFieldProps) => (
  <button
    {...aria}
    type="button"
    role="switch"
    aria-checked={checked}
    disabled={disabled}
    className={classNames("switch-field", { "switch-field-on": checked })}
    onClick={() => onChange(!checked)}
  >
    <span className="switch-field-knob" />
  </button>
)

export default SwitchField
